import {
  RedirectContainers,
  ResultAction,
  ResultActionMethods,
  WindowNames,
} from '@cashier/cashier-model';

import { ActionTypes } from '../../models';

interface ToProviderIframeConfigurationInput {
  paymentMethodContainer: RedirectContainers;
  resultAction: ResultAction;
}

interface ProviderIframeConfiguration {
  name: string;
  width: number | null;
  height: number | null;
  src: string;
  ref: (frame: HTMLIFrameElement) => void;
  actionType: ActionTypes;
}

const SIZE_OFFSET = 20;

export const toProviderIframeConfiguration = ({
  paymentMethodContainer,
  resultAction,
}: ToProviderIframeConfigurationInput): null | ProviderIframeConfiguration => {
  if (RedirectContainers.IFRAME !== paymentMethodContainer) {
    return null;
  }

  const { method, width, height, url, output, parameters } = resultAction;

  const getActionType = (): ActionTypes => {
    if (output) {
      return ActionTypes.RENDER_CONTENT;
    }

    if (ResultActionMethods.POST === method) {
      return ActionTypes.FORM_SUBMIT;
    }

    return ActionTypes.REDIRECT;
  };
  const getSrc = (): string => {
    if (ResultActionMethods.GET === method) {
      return `${url}?${new URLSearchParams(parameters).toString()}`;
    }

    return 'about:blank';
  };

  const ref = (frame: HTMLIFrameElement) => {
    if (!frame || !frame.contentDocument || !output) {
      return;
    }

    const doc = frame.contentDocument;

    doc.open();
    doc.write(output);
    doc.close();
  };

  return {
    name: WindowNames.Iframe,
    width: width ? width + SIZE_OFFSET : null,
    height: height ? height + SIZE_OFFSET : null,
    ref,
    src: getSrc(),
    actionType: getActionType(),
  };
};
